export default __webpack_public_path__ + "static/media/email-blocker.49e93236.svg";